"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EVENTS = exports.triggerEvent = exports.clearEvent = exports.onEvent = void 0;
var callbacks = {};
/**
 * Registers a callback to be called when an event with type *action* is triggered.
 * @param {string} action The type of event to listen for
 * @param {function} callback The callback receives any data passed when triggering the event as parameters
 * @example
 *
 * import { onEvent, triggerEvent } from '@demant/wdh';
 *
 * onEvent('my-event', () => {
 *   // my-event was triggered
 * });
 *
 * triggerEvent('my-event');
 *
 * onEvent('my-user-event', (firstname, lastname) => {
 *   // my-user-event triggered with data (firstname, lastname)
 * });
 *
 * triggerEvent('my-user-event', 'John', 'Doe');
 */

var onEvent = function onEvent(action, callback) {
  if (!(action in callbacks)) {
    callbacks[action] = [];
  }

  callbacks[action].push(callback);
};
/**
 * Removes the listener *callback* for events with type *action*.
 * @param {string} action The type of event
 * @param {function} callback The callback to remove from listeners
 */


exports.onEvent = onEvent;

var clearEvent = function clearEvent(action, callback) {
  if (action in callbacks) {
    if (callback !== undefined && callback !== '') {
      var callbackIndex = callbacks[action].indexOf(callback);

      if (callbackIndex > -1) {
        callbacks[action].splice(callbackIndex, 1);
      }
    } else {
      delete callbacks[action];
    }
  }
};
/**
 * Triggers the event with type *action*. Executing listeners for that action.
 * @param {string} action The type of event to trigger
 * @param {...*} args The data to pass on to listeners
 * @example
 *
 * import { onEvent, triggerEvent } from '@demant/wdh';
 *
 * onEvent('my-event', () => {
 *   // my-event was triggered
 * });
 *
 * triggerEvent('my-event');
 *
 * onEvent('my-user-event', (firstname, lastname) => {
 *   // my-user-event triggered with data (firstname, lastname)
 * });
 *
 * triggerEvent('my-user-event', 'John', 'Doe');
 */


exports.clearEvent = clearEvent;

var triggerEvent = function triggerEvent(action) {
  if (action in callbacks) {
    var handler;
    var i;
    var len;
    var handlers = callbacks[action];

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    for (i = 0, len = handlers.length; i < len; i += 1) {
      handler = handlers[i];
      handler.apply(void 0, args);
    }
  }

  if (typeof document !== 'undefined') {
    var event = document.createEvent('Event');
    event.initEvent(action, true, true);
    document.body.dispatchEvent(event);
  }
};

exports.triggerEvent = triggerEvent;
var EVENTS = {
  RESIZE_DONE: 'resizeDone',
  SELECT_ADDED: 'selectAdded',
  SELECT_UPDATED: 'selectUpdated',
  BUILDER_DONE: 'builderDone'
};
exports.EVENTS = EVENTS;